// BJS 20250407 - Migrated to TypeScript ConsignmentPlansConsignmentsComponent

//(function () {
//	'use strict';

//	var module = angular.module("imApp");

//	module.factory("consignmentPlansConsignmentsService", ['p2DataTaskService', function (p2DataTaskService) {
//		var service = {
//			loadDeliveryMethods: function () {
//				return p2DataTaskService.call(1693, {});
//			},
//			loadSettings: function () {
//				return p2DataTaskService.call(1692, {});
//			},
//			loadConsignments: function (parms) {
//				return p2DataTaskService.call(1680, parms);
//			},
//			remember: function (variablename, variablevalue) {
//				return p2DataTaskService.call(616, {
//					variablename: variablename,
//					variablevalue: variablevalue
//				});
//			},
//			updateColumnResize: function (parms) {
//                return p2DataTaskService.call(1457, parms);
//			}
//		};

//		return service;
//	}]);
//})();
